// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/rescue.css
// module id = 549
// module chunks = 2